export default class ExpertService {
  /* @ngInject */
  constructor(NetworkService) {
    this.NetworkService = NetworkService;
    this.expertCache = {};
  }

  getExperts(data) {
    return this.NetworkService.getExperts(data);
  }

  getExpert(id) {
    return this.expertCache[id] ?
      Promise.resolve(this.expertCache[id]) :
      this.NetworkService
        .getExpert(id)
        .then((data) => {
          this.expertCache[id] = data;
          return data;
        });
  }
}



// WEBPACK FOOTER //
// ./src/services/expert.service.js